<template>
  <section class="flex flex-col items-center">
    <div class="w-full sm:max-w-368 px-16 sm:px-0">
      <Breadcrumb
        header="Cancel"
        class="p-0 mt-16"
        :to="isEdit ? `/adventures/${$store.getters['adventures/adventureId']}/edit/` : `/adventures/new/availability`"
      />
      <form class="flex flex-col mt-24" @submit.prevent="submitForm">
        <h1 class="text-h3 mb-16">In general, when are you available?</h1>
        <div class="mb-32">
          <div
            v-for="day in Object.keys(availability)"
            :key="day"
            class="border-solid border-b-1 border-grey-divider-subdued last:border-b-0 flex flex-row justify-between items-center h-72"
          >
            <Checkbox
              class="capitalize"
              :value="day"
              :modelValue="checkedDays"
              :labelName="day.substring(0, 3)"
              labelClass="m-0"
              @update:modelValue="checkboxHandler"
            />
            <div v-if="checkedDays.includes(day)" class="flex flex-row justify-between w-7/12">
              <button
                role="checkbox"
                :aria-checked="checkDay(day, 'morning')"
                class="primary-focus"
                @click.prevent="availabilityHandler(day, 'morning')"
              >
                <Morning :available="checkDay(day, 'morning')" />
              </button>
              <button
                role="checkbox"
                :aria-checked="checkDay(day, 'afternoon')"
                class="primary-focus"
                @click.prevent="availabilityHandler(day, 'afternoon')"
              >
                <Afternoon :available="checkDay(day, 'afternoon')" />
              </button>
              <button
                role="checkbox"
                :aria-checked="checkDay(day, 'evening')"
                class="primary-focus"
                @click.prevent="availabilityHandler(day, 'evening')"
              >
                <Evening :available="checkDay(day, 'evening')" />
              </button>
            </div>
            <div v-else><span class="text-body-3 text-grey-body">Unavailable</span></div>
          </div>
        </div>
        <div
          class="w-full mt-8 sm:mt-0 fixed sm:static bottom-0 left-0 p-16 sm:p-0 border-t-1 border-solid border-grey-divider-subdued bg-foreground sm:border-0"
        >
          <Button value="Save" size="medium" class="w-full" :loading="loading" />
        </div>
      </form>
    </div>
  </section>
</template>

<script lang="ts">
import cloneDeep from 'lodash/cloneDeep';
import Breadcrumb from '../../../../components/breadcrumb/Breadcrumb.vue';
import Button from '../../../../components/button/Button.vue';
import Checkbox from '../../../../components/checkbox/Checkbox.vue';
import Morning from '../../../../icons/Morning.vue';
import Afternoon from '../../../../icons/Afternoon.vue';
import Evening from '../../../../icons/Evening.vue';
import { UPDATE_SITTER_PROFILE } from '../../../../graphql/adventures/mutations';

export default {
  name: 'AvailabilityEdit',
  components: { Button, Breadcrumb, Checkbox, Morning, Afternoon, Evening },
  props: {
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      checkedDays: [] as String[],
      availability: {
        ...{
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
        },
        ...cloneDeep(this.$store.getters['adventures/adventureDraft'].sitterAvailability),
      },
    };
  },
  mounted(): void {
    Object.keys(this.availability).forEach((day) => {
      if (this.availability[day]?.length) {
        this.checkedDays.push(day);
      }
    });
  },
  methods: {
    checkDay(day, time): Boolean {
      return !!this.availability[day]?.includes(time);
    },
    async submitForm(): Promise<any> {
      this.loading = true;
      await this.$store.dispatch('adventures/updateStore', { sitterAvailability: this.availability });
      await this.updateSitterProfile();
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/availability',
      });
    },
    updateSitterProfile() {
      this.$apollo.mutate({
        mutation: UPDATE_SITTER_PROFILE,
        variables: {
          input: { sitterAvailability: this.availability },
        },
      });
    },
    availabilityHandler(day: string = '', time: string = ''): void {
      const { availability } = this;
      if (availability[day] === null) {
        availability[day] = [time];
      } else if (availability[day].includes(time)) {
        // the grapqhl schema switches data types between null and Array for times..
        if (availability[day].length > 1) {
          availability[day] = availability[day].filter((dataTime) => dataTime !== time);
        } else {
          availability[day] = null;
        }
      } else {
        availability[day].push(time);
      }
    },
    checkboxHandler(days: String[]) {
      Object.keys(this.availability).forEach((day) => {
        if (!days.includes(day)) {
          this.availability[day] = [];
        }
      });
      this.checkedDays = days;
    },
  },
};
</script>
